import { Provider } from 'react-redux';
import { createRoot } from 'react-dom/client';

import { store } from 'store/configureStore';

import Sentry from 'services/Sentry/SentryInstance';

import { isProd } from './helpers/utils';

import { initOneTrust } from './services/OneTrust/initOneTrust';
import { initDatadogRum } from './services/DataDog';
import reportWebVitals from './reportWebVitals';
import App from './App';

Sentry.init();

isProd() && initOneTrust();

initDatadogRum();

const rootDiv = document.getElementById('root');

if (rootDiv) {
    const root = createRoot(rootDiv);

    root.render(
        <Provider store={store}>
            <App />
        </Provider>
    );
}

reportWebVitals(() => {});
